<template>
<div class="colorpicker">
  <div class="colorpicker__container">
    <h3 class="title">Choose App Colors</h3>
    <form class="color-preview" name="colorPickerForm">
      <div class="color-preview__group">
        <label for="primaryColorPicker" class="color-input-label">Primary</label>
        <input type="color" name="primaryColorPicker" id="primaryColorPicker" :value="this.primary === undefined ? this.primaryColor : this.primary" @change="onColorChange()">
      </div>
      <div class="color-preview__group">
        <label for="secondaryColorPicker" class="color-input-label">Secondary</label>
        <input type="color" name="secondaryColorPicker" id="secondaryColorPicker" :value="this.secondary === undefined ? this.secondaryColor : this.secondary" @change="onColorChange()">
      </div>
    </form>
    <div class="colorpicker__upload">
      <button @click="appColorsUpload()" id="save_logo" class="btn upload_btn"><i class="material-icons">save</i><span class="title">Save Colors</span></button>
    </div>
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appActions } from '@/constants/'

const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'theappcolorpicker',
  props: {
    primaryColor: null,
    secondaryColor: null
  },
  data: function () {
    return {
      primary: '',
      secondary: ''
    }
  },
  mounted () {
    this.primary = this.primaryColor
    this.secondary = this.secondaryColor
  },
  methods: {
    onColorChange () {
      this.primary = document.querySelector('#primaryColorPicker').value
      this.secondary = document.querySelector('#secondaryColorPicker').value
      this.$store.dispatch('applicationState/' + appActions.UPDATE_APP_SETTINGS_COLORS, {
        primary: this.primary,
        secondary: this.secondary
      })
    },
    appColorsUpload () {
      let colors = {
        colors: {
          primary: this.primary,
          secondary: this.secondary
        }
      }
      this.$store.dispatch('applicationState/' + appActions.SAVE_APP_SETTINGS_COLORS, {
        name: this.appName.replace(' ', ''),
        colors: colors
      })
    }
  },
  computed: {
    ...mapState({
      appColors: state => state.appColors,
      appName: state => state.appName
    })
  }
}
</script>

<style lang="scss">
@import '@/scss/main.scss';

.colorpicker {
  &__container {
    position: relative;
    max-width: rem(160);
    margin: 0 auto rem(10) auto;

    @include breakpoint(tablet) {
      margin: 0 auto rem(35) auto;
    }

    .title {
      margin: rem(10) auto;
    }

    .color-preview {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;

      &__group {
        width: rem(50);

        label {
          font-size: rem(12);
        }
      }
    }
  }

  &__upload {
    .upload_btn {
      color: $light;
      background-color: rgba($primary, 0.8);
      padding: rem(8) rem(14) rem(8) rem(16);

      .title {
        margin-left: rem(-8);
        font-size: rem(14);
      }

      .material-icons {
        color: rgba($light, 1);
        left: rem(-14);

        &:before {
          top: rem(-14);
          left: rem(-6);
          width: rem(38);
          height: rem(37);
          border-radius: rem(10) 0 0 rem(10);
          border-top-width: 1px;
          border-top-color: $primary;
          border-top-style: solid;
          border-bottom-width: 1px;
          border-bottom-color: $primary;
          border-bottom-style: solid;
          border-left-width: 1px;
          border-left-color: $primary;
          border-left-style: solid;
        }
      }

      &:hover {
        background-color: rgba($primary, 1);
        padding: rem(8) rem(14) rem(8) rem(8);
        transition: 0.4s;

        .title {
          margin-left: rem(-2);
          font-size: rem(14);
          transition: 0.4s;
        }

        .material-icons {
          color: rgba($primary, 1);
          left: rem(-18);

          &:before {
            top: rem(-14);
            left: rem(-6);
            width: rem(38);
            height: rem(37);
            border-radius: rem(10) 0 0 rem(10);
            border-top-width: 1px;
            border-top-color: $primary;
            border-top-style: solid;
            border-bottom-width: 1px;
            border-bottom-color: $primary;
            border-bottom-style: solid;
            border-left-width: 1px;
            border-left-color: $primary;
            border-left-style: solid;
            opacity: 1;
            transition: 0.5s;
            transition-delay: 0.1s;
            transition-property: all;
          }

          &:after {
            opacity: 1;
            left: rem(26);
            transition: 0.2s;
            transition-delay: 0.4s;
            transition-property: all;
          }
        }
      }

      &:active {
        transform: translateY(4px);
        transition: 0.2s;
      }
    }
  }
}
</style>
